import React, { useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../config";
import "./Header.css";
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";
import GoogleButton from "./GoogleAuth";
import { toast } from "react-toastify";

const Header = () => {
  const toggleOverlay = () => setIsOpen((prev) => !prev);
  const [isOpen, setIsOpen] = useState(false);
  const [ActiveTab, setActiveTab] = useState("write");
  const googleanalytics = process.env.REACT_APP_GOOGLE_ANALYITCS_ID;
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [activeSliderButton, setActiveSliderButton] = useState("home");
  const navigate = useNavigate();
  const googleAuthRef = useRef(null);
  const currentPage = window.location.pathname;
  const handleSliderButtonClick = (callback) => {
    callback();
    setIsOpen(false);
  };
  const handleHomeClick = () => {
    navigate("/");
    setActiveTab("write");
    logEvent(analytics, "Home_btn_legal", {
      button_name: "home_button",
    });
  };
  const handleBuyPremiumClick = () => {
    navigate("/premium");
    logEvent(analytics, "Premium_btn_legal", {
      button_name: "Premium_page",
    });
  };
  const handlePrivacyPolicyClick = () => {
    navigate("/privacy");
    setActiveTab("privacy");
    logEvent(analytics, "Privacy_btn_legal", {
      button_name: "Privacy_page",
    });
  };

  const handleRefundPolicyClick = () => {
    navigate("/refundpolicy");
    setActiveTab("refund");
    logEvent(analytics, "Refund_btn_legal", {
      button_name: "refund_page",
      page: "legal_home",
      action: "opens_refund_page",
    });
  };

  const handleTermsClick = () => {
    navigate("/terms&condition");
    setActiveTab("terms");
    logEvent(analytics, "terms&condition_btn_legal", {
      button_name: "terms&condition_page",
      page: "legal_home",
      action: "opens-terms-page",
    });
  };
  const handleDashboardClick = () => {
    navigate("/dashboard");
    setActiveTab("dashboard");
    logEvent(analytics, "dashboard_btn_legal", {
      button_name: "dashboard_page",
      page: "legal_home",
      action: "opens_privacy_page",
    });
  };

  const handleLoginSuccess = (response) => {
    setTimeout(() => {}, 500);
  };

  const handleLoginFailure = (error) => {
    toast.error("Google login failed. Please try again.");
  };

  return (
    <>
      <div className="header_mobile">
        <img
          src={config.hamburger}
          alt="Menu"
          className="hamburger"
          onClick={toggleOverlay}
        />
        <h1 className="title_header"> <img src={config.logo} alt="logo" className="logo_header"/>Ai Legal Document</h1>

        <div className="header_buttons">
          <button
            className="header_button"
            onClick={() => {
              navigate("/");
            }}
          >
            Home
          </button>
          <button
            className="header_button"
            onClick={() => handleDashboardClick()}
          >
            Dashboard
          </button>
          <button
            className="header_button"
            onClick={() => handleBuyPremiumClick()}
          >
            Pricing
          </button>
          <button
            className="header_button"
            onClick={() =>
              window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
              })
            }
          >
            Contact Us
          </button>
          <button
            className="header_button"
            onClick={() =>
              window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
              })
            }
          >
            About Us
          </button>
          <GoogleButton
            id="header_button"
            ref={googleAuthRef}
            onLoginSuccess={handleLoginSuccess}
            onLoginFailure={handleLoginFailure}
          />
        </div>
      </div>

      {isOpen && (
        <div className="overlay" onClick={toggleOverlay}>
          <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
            <div className="topslider">
              <div className="close-icon" onClick={toggleOverlay}>
                &#10005;
              </div>
              <img src={config.logo} alt="Frame" className="frame" />
            </div>
            <div className="button-container-slider">
              <button
                className="buy-premium-slider"
                onClick={() => handleSliderButtonClick(handleBuyPremiumClick)}
              >
                <img
                  src={config.crown}
                  alt="crownSlider"
                  className="slidercrown"
                />{" "}
                Buy Premium
              </button>
              <div className="buttonscrollonslider">
                <button
                  className={`Home_btn_slider ${
                    activeSliderButton === "home" ? "active" : ""
                  }`}
                  onClick={() => {
                    handleSliderButtonClick(handleHomeClick);
                    setActiveSliderButton("home");
                  }}
                >
                  <span>
                    <img
                      src={config.homeSlider}
                      alt="Home"
                      className="slider-Homeimg"
                    />
                  </span>{" "}
                  Home
                </button>
                {/*    <button className={`Home_btn_slider ${activeSliderButton === 'blog' ? 'active' : ''}`}
                                 onClick={() => {
                                    handleSliderButtonClick(handleBlogClick);
                                    setActiveSliderButton('Blog'); 
                                }}>
                                    <span><img src={config.blogSlider} alt="Blog" className='slider-Homeimg' /></span> Dashboard
                                </button> */}
                <button
                  className={`Home_btn_slider ${
                    activeSliderButton === "privacy" ? "active" : ""
                  }`}
                  onClick={() => {
                    handleSliderButtonClick(handlePrivacyPolicyClick);
                    setActiveSliderButton("privacy");
                  }}
                >
                  <span>
                    <img
                      src={config.privacySlider}
                      alt="Privacy"
                      className="slider-Homeimg"
                    />
                  </span>{" "}
                  Privacy Policy
                </button>
                <button
                  className={`Home_btn_slider ${
                    activeSliderButton === "refund" ? "active" : ""
                  }`}
                  onClick={() => {
                    handleSliderButtonClick(handleRefundPolicyClick);
                    setActiveSliderButton("Refund");
                  }}
                >
                  <span>
                    <img
                      src={config.refundSlider}
                      alt="Refund"
                      className="slider-Homeimg"
                    />
                  </span>{" "}
                  Refund Policy
                </button>
                <button
                  className={`Home_btn_slider ${
                    activeSliderButton === "terms" ? "active" : ""
                  }`}
                  onClick={() => {
                    handleSliderButtonClick(handleTermsClick);
                    setActiveSliderButton("Terms");
                  }}
                >
                  <span>
                    <img
                      src={config.termsSlider}
                      alt="Terms"
                      className="slider-Homeimg"
                    />
                  </span>{" "}
                  Terms & Condition
                </button>
              </div>

              <GoogleButton
                id="login_slider"
                onLoginSuccess={handleLoginSuccess}
                onLoginFailure={handleLoginFailure}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
